module.exports = __webpack_public_path__ + "static/media/04_wall_anchor.f521114b.png";